import { FeedbotThunk } from '../../../store/types'
import { isUnsavedSelector } from '../../../store/socketServer'
import { endpointHelpers } from '../endpointHelpers'
import { alertHavingUnsavedChanges } from '../utils/bootbox'
import { alert } from '../../../lib/bootbox'
import { currentBotConfigurationSelector } from '../selectors/currentBotConfigurationSelector'
import { currentBotEnvironmentTypeSelector } from '../selectors/currentBotEnvironmentTypeSelector'
import { openBotIdSelector } from '../../../store/app/selectors'
import { lastVersionStringForCurrentBotSelector } from '../../../store/socketServer/selectors'

export const createDevBotForCurrentBot =
  (): FeedbotThunk<Promise<string | void>> => async (dispatch, getState) => {
    const currentBotId = openBotIdSelector(getState())
    const currentConfig = currentBotConfigurationSelector(getState())
    const currentBotVersion = lastVersionStringForCurrentBotSelector(getState())

    if (!currentBotId || !currentConfig || !currentBotVersion) {
      return
    }

    if (isUnsavedSelector(getState())) {
      return alertHavingUnsavedChanges()
    }

    if (currentBotEnvironmentTypeSelector(getState()) === 'test') {
      return alertTryingToCreateTestBotForTestBot()
    }

    const newBotId = `${currentBotId}-test`

    await dispatch(endpointHelpers.createTestEnvironmentForCurrentBot.initiate()).unwrap()

    return newBotId
  }

const alertTryingToCreateTestBotForTestBot = () =>
  alert({
    title: '❌ Test bot',
    message: 'The test bot cannot have a test bot!'
  })
